import {
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaChevronLeft,
  FaChevronRight,
  FaEllipsisH
} from '@fareye/utils'
import React from 'react'
import { PaginationActions, DarkViewPageList } from '../styled'
import { IPagination } from '../types'

const DynamicPagination = (props: IPagination) => {
  const {
    pageSize,
    gotoPage,
    pageIndex,
    dataLoading,
    totalElements,
    showPagination
  } = props
  if (!showPagination || !totalElements) {
    return null
  }

  const totalPages = Math.ceil(totalElements / pageSize)
  const totalPageIndexToShow = totalPages > 3 ? 4 : totalPages

  const lowest =
    totalPages - pageIndex > totalPageIndexToShow
      ? pageIndex
      : Math.max(0, totalPages - totalPageIndexToShow)
  const highest = lowest + totalPageIndexToShow - 1
  const isPrev = totalPages > totalPageIndexToShow && lowest > 1
  const isNext = totalPages > totalPageIndexToShow && highest < totalPages - 2

  const canNext = totalElements > (pageIndex + 1) * pageSize && !dataLoading
  const canPrev = pageIndex > 0 && !dataLoading

  let renderPagination
  if (totalPages < 5) {
    renderPagination = (
      <DarkViewPageList>
        <li
          style={{ cursor: canPrev ? 'pointer' : 'not-allowed' }}
          onClick={() => canPrev && gotoPage(pageIndex - 1)}
        >
          <FaChevronLeft size={10} color={canPrev ? 'inherit' : '#cfcfcf'} />
        </li>
        {new Array(totalPageIndexToShow).fill('').map((i, j) => (
          <li
            className={j === pageIndex ? 'active' : ''}
            key={j}
            style={{ cursor: dataLoading ? 'not-allowed' : 'pointer' }}
            onClick={() => !dataLoading && gotoPage(j)}
          >
            {j + 1}
          </li>
        ))}
        <li
          style={{ cursor: canNext ? 'pointer' : 'not-allowed' }}
          onClick={() => canNext && gotoPage(pageIndex + 1)}
        >
          <FaChevronRight size={10} color={canNext ? 'inherit' : '#cfcfcf'} />
        </li>
      </DarkViewPageList>
    )
  } else {
    renderPagination = (
      <DarkViewPageList>
        <li
          style={{ cursor: canPrev ? 'pointer' : 'not-allowed' }}
          onClick={() => canPrev && gotoPage(pageIndex - 1)}
        >
          <FaChevronLeft size={10} color={canPrev ? 'inherit' : '#cfcfcf'} />
        </li>
        {lowest !== 0 && (
          <li
            style={{ cursor: dataLoading ? 'not-allowed' : 'pointer' }}
            onClick={() => !dataLoading && gotoPage(0)}
          >
            {1}
          </li>
        )}
        {isPrev && (
          <li
            className="bring-more"
            style={{ cursor: dataLoading ? 'not-allowed' : 'pointer' }}
            onClick={() =>
              !dataLoading && gotoPage(pageIndex > 4 ? pageIndex - 4 : 0)
            }
          >
            <FaEllipsisH className="ellipsis" size={10} color="#797979" />
            <FaAngleDoubleLeft className="double-angle" size={10} />
          </li>
        )}
        {new Array(totalPageIndexToShow).fill('').map((i, j) => (
          <li
            key={j}
            className={lowest + j === pageIndex ? 'active' : ''}
            style={{ cursor: dataLoading ? 'not-allowed' : 'pointer' }}
            onClick={() => !dataLoading && gotoPage(lowest + j)}
          >
            {lowest + j + 1}
          </li>
        ))}
        {isNext && (
          <li
            className="bring-more"
            style={{ cursor: dataLoading ? 'not-allowed' : 'pointer' }}
            onClick={() =>
              !dataLoading &&
              gotoPage(
                pageIndex + 4 < totalPages - 1 ? pageIndex + 4 : totalPages - 1
              )
            }
          >
            <FaEllipsisH className="ellipsis" size={10} color="#797979" />
            <FaAngleDoubleRight className="double-angle" size={10} />
          </li>
        )}
        {highest < totalPages - 1 && (
          <li
            style={{ cursor: dataLoading ? 'not-allowed' : 'pointer' }}
            onClick={() => !dataLoading && gotoPage(totalPages - 1)}
          >
            {totalPages}
          </li>
        )}
        <li
          style={{ cursor: canNext ? 'pointer' : 'not-allowed' }}
          onClick={() => canNext && gotoPage(pageIndex + 1)}
        >
          <FaChevronRight size={10} color={canNext ? 'inherit' : '#cfcfcf'} />
        </li>
      </DarkViewPageList>
    )
  }

  return (
    <PaginationActions data-testid="pagination-actions">
      {renderPagination}
    </PaginationActions>
  )
}

export default DynamicPagination
